import {EventEmitter, Injectable} from '@angular/core';
import {
  ClusterFlowDetails,
  ComboboxSelectionItem, DCNetscopeResourceWithName,
  DuckDbDashboardData, FlowDetail,
  InfrastructureVersion,
  TemporalParameter
} from "@app/netscope/model/data-models";
import {BehaviorSubject, forkJoin, pipe, take, ReplaySubject, Subject, combineLatestWith} from "rxjs";
import {combineLatest} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NetscopeUiService {

  viewLabelChangeEmitter: EventEmitter<string> = new EventEmitter();
  iconShapeChangeEmitter: EventEmitter<string> = new EventEmitter();
  errorStateChangeEmitter: EventEmitter<boolean> = new EventEmitter();
  loadingStateChangeEmitter: EventEmitter<boolean> = new EventEmitter();
  onResizeEventEmitter: EventEmitter<any> = new EventEmitter();
  themeChangeEmitter: EventEmitter<boolean> = new EventEmitter();

  selectedDateChangeEmitter: EventEmitter<[number, number, string]> = new EventEmitter();

  public selectedResourcesChangeEmitter: EventEmitter<ComboboxSelectionItem[]> = new EventEmitter();
  public languageChangeEventEmitter: EventEmitter<string> = new EventEmitter();
  public updateUrlRequestedEventEmitter: EventEmitter<string> = new EventEmitter();

  public infrastructureVersionSubject = new ReplaySubject<InfrastructureVersion>(1);
  public dashboardFlowDetailsSubject = new ReplaySubject<FlowDetail[]>(1);
  public threatsFlowDetailsSubject = new ReplaySubject<FlowDetail[]>(1);
  public dashboardGraphDataSubject = new ReplaySubject<Object>(1);
  public clustersFlowDetailsSubject = new ReplaySubject<ClusterFlowDetails>(1);
  public temporalParametersSubject = new ReplaySubject<TemporalParameter>(1);

  public comboboxSelectionItemSubject = new BehaviorSubject<ComboboxSelectionItem[]>([]);
  public duckDbDataSubject = new ReplaySubject<DuckDbDashboardData>(1);
  public duckDbRefinedDataSubject = new ReplaySubject<DuckDbDashboardData>(1);
  public darkModeStatusSubject = new ReplaySubject<boolean>(1);

  private isLoadingMap: Map<string, boolean> = new Map();

  constructor() {
    this.darkModeStatusSubject.next(false);
  }

  setViewLabel(viewLabel: string) {
    this.viewLabelChangeEmitter.emit(viewLabel);
  }

  setIconShape(shape: string) {
    this.iconShapeChangeEmitter.emit(shape);
  }

  setLoadingState(loadingState: boolean, key: string) {
    for (let k of this.isLoadingMap.keys()) {
      console.log(` (1) ${k} -> ${this.isLoadingMap.get(k)}`);
    }

    let beforeState = Array.from(this.isLoadingMap.values()).some((v) => v == true);
    console.log(`loadingState[${key}]: ${loadingState}`);
    this.isLoadingMap.set(key, loadingState);
    let afterState = Array.from(this.isLoadingMap.values()).some((v) => v == true);

    for (let k of this.isLoadingMap.keys()) {
      console.log(` (2) ${k} -> ${this.isLoadingMap.get(k)}`);
    }

    this.loadingStateChangeEmitter.emit(afterState);
  }

  setLoadingErrorStage(loadingErrorState: boolean) {
    this.errorStateChangeEmitter.emit(loadingErrorState);
  }

  setSelectedDate(startTime: number, endTime: number, timeperiod: string) {
    this.selectedDateChangeEmitter.emit([startTime, endTime, timeperiod]);
  }

   setTheme(isLightTheme: boolean) {
    this.darkModeStatusSubject.next(!isLightTheme);
    this.themeChangeEmitter.emit(isLightTheme);
  }

  switchFocus = (vm, mode="focus") => {
    combineLatest([this.comboboxSelectionItemSubject]).pipe(
      take(1),
    ).subscribe(([currentComboboxSelection]) => {
      let focusedVmsIds = currentComboboxSelection
        .filter((r) => r.mode === mode)
        .map((s) => s.resource.uuid);

      let currentVmId = vm.id !== undefined ? vm.id : vm.uuid;
      // let mode = "focus";

      if (currentVmId.startsWith("vim.group:")) {
          mode = "appgroup";
          currentVmId = currentVmId.split(":")[1];
          vm.name = currentVmId;
      }

      if (focusedVmsIds.indexOf(currentVmId) !== -1) {
        currentComboboxSelection = currentComboboxSelection
          .filter((s) => !(s.mode === mode && s.resource.uuid === currentVmId));
      } else {
        currentComboboxSelection.push(new ComboboxSelectionItem(new DCNetscopeResourceWithName(currentVmId, vm.name), mode));
      }
      this.comboboxSelectionItemSubject.next(currentComboboxSelection);
      this.selectedResourcesChangeEmitter.emit(currentComboboxSelection);
    });
  }
}
